export default __webpack_public_path__ + "static/media/happy.f1fa07b5.png";